import axios from "axios";

export const featureFlagApi = {
  async get() {
    const response = await axios.get(`/api/featureFlag`);
    return response.data.result;
  },
};
